(function(){
  var d=document;
  // split headline into line masks (split on the <em>)
  d.querySelectorAll('.js-split').forEach(function(h){
    var em=h.querySelector('em'); if(!em) return;
    var first=h.innerHTML.split('<em>')[0].trim();
    h.innerHTML='<span class="ln"><span>'+first+'</span></span><span class="ln"><span><em>'+em.innerHTML+'</em></span></span>';
    requestAnimationFrame(function(){requestAnimationFrame(function(){h.classList.add('is-in')})});
  });
  // reveals with stagger
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(!e.isIntersecting) return;
      var sib=[].slice.call(e.target.parentNode.children).filter(function(n){return n.classList.contains('reveal')});
      e.target.style.transitionDelay=Math.min(sib.indexOf(e.target),5)*90+'ms';
      e.target.classList.add('is-in'); io.unobserve(e.target);
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:.08});
  d.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  // header shrink
  var hdr=d.querySelector('.fbb-header');
  if(hdr) addEventListener('scroll',function(){hdr.classList.toggle('is-scrolled',scrollY>40)},{passive:true});
  // mobile drawer
  var b=d.querySelector('.fbb-burger'),dr=d.querySelector('.fbb-drawer');
  if(b&&dr){b.addEventListener('click',function(){var o=dr.hidden;dr.hidden=!o;b.setAttribute('aria-expanded',o)});
    dr.addEventListener('click',function(e){if(e.target.tagName==='A'){dr.hidden=true;b.setAttribute('aria-expanded','false')}})}
  // method tabs (signature interactive)
  d.querySelectorAll('.fbb-method').forEach(function(sec){var steps=sec.querySelectorAll('.fbb-step'),panels=sec.querySelectorAll('.fbb-panel');
  function show(i){steps.forEach(function(s,j){s.classList.toggle('is-active',i===j);s.setAttribute('aria-selected',i===j)});
    panels.forEach(function(p,j){p.classList.toggle('is-active',i===j)})}
  steps.forEach(function(s,i){s.addEventListener('click',function(){show(i)});
    s.addEventListener('keydown',function(e){if(e.key==='ArrowDown'||e.key==='ArrowRight'){e.preventDefault();var n=(i+1)%steps.length;steps[n].focus();show(n)}
      if(e.key==='ArrowUp'||e.key==='ArrowLeft'){e.preventDefault();var p=(i+steps.length-1)%steps.length;steps[p].focus();show(p)}})});});
  // spotlight glow follows cursor
  var sm=d.querySelector('.fbb-spot__media');
  if(sm&&matchMedia('(hover:hover)').matches){sm.addEventListener('pointermove',function(e){var r=sm.getBoundingClientRect();
    sm.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');sm.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%')})}
  // AJAX add to bag (falls back to normal /cart/add POST without JS)
  var toast;
  function showToast(msg){ if(!toast){toast=d.createElement('div');toast.className='fbb-toast';toast.setAttribute('role','status');d.body.appendChild(toast)}
    toast.innerHTML=msg; toast.classList.add('is-on'); clearTimeout(toast._t); toast._t=setTimeout(function(){toast.classList.remove('is-on')},3800)}
  d.addEventListener('submit',function(e){
    var f=e.target; if(!f.classList||!f.classList.contains('fbb-atc')) return;
    e.preventDefault(); var btn=f.querySelector('button'); if(btn) btn.disabled=true;
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok) throw j; return j})})
      .then(function(item){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
        d.querySelectorAll('.fbb-cart__count').forEach(function(n){n.textContent=c.item_count});
        showToast('Added: '+item.product_title+' <a href="/cart">View bag</a>');})})
      .catch(function(err){showToast((err&&err.description)||'Could not add to bag')})
      .finally(function(){if(btn) btn.disabled=false});
  });
})();

/* v3: drag-to-scroll social rail */
(function(){document.querySelectorAll('.fbb-social__rail').forEach(function(r){var down=false,x0=0,s0=0,moved=false;
r.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;x0=e.clientX;s0=r.scrollLeft;r.style.scrollSnapType='none';r.style.cursor='grabbing'});
window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-x0;if(Math.abs(dx)>4)moved=true;r.scrollLeft=s0-dx});
window.addEventListener('pointerup',function(){if(!down)return;down=false;r.style.scrollSnapType='';r.style.cursor=''});
r.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false}},true);
r.addEventListener('dragstart',function(e){e.preventDefault()});});})();
